class NavBrand extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

    const hash = window.location.hash;
    if (hash) {
      const letter = hash.replace('#', '').toUpperCase();
      const target = document.querySelector(`.line[rel="${letter}"]`);
      if (target) {
        const stickyHeader = document.querySelector('sticky-header');
        const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
        const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }

    this.querySelectorAll('.letter-filter a').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const letter = link.textContent.trim();
        const target = document.querySelector(`.line[rel="${letter}"]`);
        if (target) {
          const stickyHeader = document.querySelector('sticky-header');
          const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
          const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      });
    });

    // Search filter input
    const inputFilter = this.querySelector('#input-search');
    if (inputFilter) {
      inputFilter.addEventListener('keyup', () => {
        const value = inputFilter.value.toLowerCase();

        // Filter list items
        const brandLists = document.querySelectorAll('.brand--list');
        brandLists.forEach(brandList => {
          const items = brandList.querySelectorAll('li');
          let visibleCount = 0;

          items.forEach(item => {
            const text = item.textContent.toLowerCase();
            const isVisible = text.includes(value);
            item.style.display = isVisible ? '' : 'none';
            if (isVisible) visibleCount++;
          });

          // Show/hide section .line
          const section = brandList.closest('.line');
          if (section) {
            section.style.display = visibleCount === 0 ? 'none' : '';
          }
        });
      });
    }

  }

}
customElements.define('nav-brand', NavBrand);